import { EntityType } from "constants/entities.enum";
import { createEntityState } from "entities/charts/factory";
import { createMergeWithDefaults } from "entities/utils";
import { EvaChartFeatures } from "types";

import { BASE_RATE_FEATURES } from "./baseRateFeatures";

const RATE_DATE_FEATURES: Partial<EvaChartFeatures> = {
  ...BASE_RATE_FEATURES,
  // Shown for a consistent menu; nothing is padded into this chart, so it cannot act.
  survivorBiasAsForecast: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: false
  }),
  typewells: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  }),
  p10: createEntityState(EntityType.P10Feature, {
    show: true,
    enabled: false
  }),
  p50: createEntityState(EntityType.P50Feature, {
    show: true,
    enabled: false
  }),
  p90: createEntityState(EntityType.P90Feature, {
    show: true,
    enabled: false
  }),
  average: createEntityState(EntityType.AverageFeature, {
    show: true,
    enabled: false
  }),
  annotations: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  })
};

export const rateDateFeatures = createMergeWithDefaults(RATE_DATE_FEATURES);
